import styled from 'styled-components';
import { Grid } from "@material-ui/core";

export const Container = styled(Grid)`
  /* .MuiFormLabel-root{
    color: #f3f;
  }
  .Mui-disabled {
    color: #f3f;
  }
  .MuiFormControlLabel-root.Mui-disabled {
    color: #f3f;
  }
  .MuiCheckbox-colorPrimary.Mui-disabled {
    color: #f3f;
  }
  .MuiFormControlLabel-label.Mui-disabled {
    color: #f3f;
  } */
`;
